module.exports = __webpack_public_path__ + "img/2-3.f2f199de.svg";